import React, {useEffect, useState} from 'react';
import {Box, Typography} from '@mui/material';
import ArrTransferList, {
  KeyValue,
} from '../../common/arr-transfer-list/ArrTransferList';
import ArrTextField from '../../common/arr-text-field/ArrTextField';

type StateType = 'enabled' | 'error' | 'inactive';
interface IProjectServerPath {
  title?: string;
  placeholder?: string;
  label?: string;
  id?: string;
  required?: boolean;
  validationFn?: (value: string) => string | boolean;
  errorText?: string;
  availableList: KeyValue[];
  selectedList: KeyValue[];
  folderValue?: string;
  onTextFieldChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onChange: (e: React.ChangeEvent<HTMLInputElement>, field: KeyValue) => void;
  type?: string;
  role?: number;
}

const ProjectServerPath: React.FC<IProjectServerPath> = ({
  title,
  placeholder,
  label,
  id,
  required = false,
  validationFn,
  errorText = 'Invalid input',
  availableList,
  selectedList,
  folderValue,
  onTextFieldChange,
  onChange,
  type,
  role,
}) => {
  const [error, setError] = useState('');
  const [listError, setListError] = useState('');
  const [showListError, setShowListError] = useState<boolean>(false);

  const handleTextFieldChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;

    if (validationFn) {
      const result = validationFn(value);
      if (result !== true) {
        setError(typeof result === 'string' ? result : errorText);
      } else {
        setError('');
      }
    }

    onTextFieldChange?.(e);
  };

  const handleServerChange = (
    e: React.ChangeEvent<HTMLInputElement>,
    field: KeyValue
  ) => {
    onChange(e, field);
    setShowListError(true);
  };

  let computedState: StateType;

  if (role === -2 || (type === 'edit' && label === 'Project Folder')) {
    computedState = 'inactive';
  } else if (error) {
    computedState = 'error';
  } else {
    computedState = 'enabled';
  }

  useEffect(() => {
    if (folderValue !== '' && validationFn) {
      const result = validationFn(folderValue ?? '');
      if (result !== true) {
        setError(typeof result === 'string' ? result : errorText);
      } else {
        setError('');
      }
    }
  }, [folderValue]);

  useEffect(() => {
    if (selectedList.length === 0 && showListError) {
      setListError(`${title} is required`);
    } else {
      setListError('');
    }
  }, [selectedList]);
  return (
    <Box className="project-server-path">
      <Typography
        className="typo-text subheading5_size server-title"
        data-testid={`project-server-path-title-${title?.replaceAll(' ', '-')}`}
      >
        {title}*
      </Typography>
      <Box className="project-server-checkbox-container">
        <Box
          className={`project-server-checkbox ${label === 'Project Folder' && 'project-file-transer-list'}`}
        >
          <ArrTransferList
            displayedList={availableList}
            selectedList={selectedList}
            onChange={handleServerChange}
            disable={type === 'edit' || role === -2}
            preSelected={type === 'edit' || role === -2}
            checkboxDataTestId={`project-server-path-transfer-list-checkbox-${title?.replaceAll(' ', '-')}`}
          />
          <Typography
            className="typo-text body4_size path-error"
            data-testid={`list-error-${title?.replaceAll(' ', '-')}`}
          >
            {showListError && listError}
          </Typography>
        </Box>

        <Box className="project-server-text-field">
          <ArrTextField
            fullWidth
            value={folderValue}
            placeholder={placeholder}
            id={id}
            label={label}
            required={required}
            onChange={handleTextFieldChange}
            state={computedState}
            supportText={error}
            dataTestId={`project-server-text-${id}`}
          />
        </Box>
      </Box>
    </Box>
  );
};

export default ProjectServerPath;
